import React from 'react';
import { Box, Typography } from '@mui/material';

const TeamSubscriptionHeader = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#333' }}>
                My Subscription
            </Typography>
        </Box>
    );
};

export default TeamSubscriptionHeader;
